import * as React from "react";
import LegalPage from "../components/legal/LegalPage";
import { termsOfService } from "../data/legal";
import { ROUTE_LINKS } from "../utils/routes";

const TermsAndConditionPage: React.FC = () => {
  return <LegalPage path={ROUTE_LINKS.termsAndCondition} document={termsOfService} />;
};

export default React.memo(TermsAndConditionPage);
